//-------------Importar librerias----------------------------
import React from 'react';
import { useNavigate } from 'react-router-dom'

// -----------Importar Componentes de Terceros------------------
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

// -----------Importar Componentes Personalizados------------------
import Buttonh from "../../../components/Button";



const ActionStepConmemoracion = ({ Compartir, Conmemoracion, DataConmemoracion, OnClickRemotoVideo, OnClickCloseConmemoracion, OnClickRegresar, HandleNext, HandleBack, HandleReset, ActiveStep, StepsLength, FormActualizar, OnClickCancelar, OnClickConmemoracion, OnClickMemoria, OnClickCompartir, Origen }) => {


    // Navegación
    const navigate = useNavigate()
    const handleClick = (link) => {
        navigate(link)
    }

    return (
        ActiveStep + 1 === StepsLength
            ?
            <Box width='100%' display='flex' flexDirection='column' alignContent='center' flexWrap='wrap'
            >
                {/* {
                    Origen === 'Nueva Memoria'
                        ?
                        <Grid sx={{ display: 'flex', alignItems: 'center' }} container columns={{ xs: 6, sm: 12, md: 12 }}>
                            <Grid sx={{ padding: { xs: '2% 0%', sm: '2%' } }} xs={6}>
                                <Buttonh Disabled={Compartir && Conmemoracion === false ? true : false} FontWeight='600 !important' FontSize={{ xs: '16px', sm: '18px' }} Text='Agregar Memoria' OnClick={OnClickMemoria} Size={{xs:'100%',sm:'200px' }} Color='#D14081' BorderColor='2px solid #D14081 !important' ColorHover='white' Textcolor='#FFFFFF' TextcolorHover='#D14081' />
                            </Grid>
                            <Grid sx={{ padding: { xs: '2% 0%', sm: '2%' } }} xs={6}>
                                <Button onClick={OnClickCompartir} variant='contained' sx={{ fontSize: { xs: '16px', sm: '18px' }, textTransform: 'none', fontFamily: 'Itaca ', border: '2px solid #D14081 !important', height: '40px', borderRadius: '5px', width: '100%', background: '#D14081', color: '#FFFFFF', '&:hover': { backgroundColor: 'white', color: '#D14081', border: '2px solid #D14081 !important' }, }} endIcon={<ShareOutlinedIcon />}>
                                    Compartir
                                </Button>
                            </Grid>
                        </Grid>
                        :
                        <></>
                }  */}

                <Grid container columns={{ xs: 6, sm: 12, md: 12 }} width={{ xs: '200px', sm: '100%' }}>


                    {
                        Origen === 'Nueva Memoria'
                            ?
                            <>
                                <Grid sx={{ padding: { xs: '0% 0% 0% 0%', sm: '0% 10px 0% 0%', marginBottom: '20px' } }} xs={6}>
                                    <Buttonh Disabled={Compartir && Conmemoracion === false ? true : false} FontSize={{ xs: '16px', sm: '18px' }} Text='Agregar Memoria' OnClick={OnClickMemoria} Size={{ xs: '100%', sm: '200px' }} Color='#fbeb04' ColorHover='white' Textcolor='#000000' BorderColor='2px solid #fbeb04 !important' TextcolorHover='black' />
                                </Grid>
                                <Grid sx={{ padding: { xs: '0% 0% 0% 0%', sm: '0% 0px 0% 10px' }, marginBottom: '20px' }} xs={6}>
                                    <Button onClick={OnClickCompartir} variant='contained' sx={{ boxShadow: 'none', fontSize: { xs: '16px', sm: '18px' }, textTransform: 'none', border: '2px solid #fbeb04 !important', borderRadius: '5px', width: { xs: '100%', sm: '200px' }, background: '#fbeb04', color: '#000000', '&:hover': { boxShadow: 'none', backgroundColor: 'white', color: 'black', border: '2px solid #fbeb04 !important' }, }} endIcon={<ShareOutlinedIcon />}>
                                        Compartir
                                    </Button>
                                </Grid>
                            </>
                            :
                            <>
                                <Grid sx={{ padding: { xs: '0% 0% 0% 0%', sm: '0% 10px 0% 0%', marginBottom: '20px' } }} xs={6} >
                                    <Buttonh FontSize={{ xs: '16px', sm: '18px' }} Text='Editar' OnClick={HandleReset} Size={{ xs: '100%', sm: '200px' }} Color='#fbeb04' ColorHover='white' Textcolor='#000000' BorderColor='2px solid #fbeb04 !important' TextcolorHover='black' />
                                </Grid>
                                <Grid sx={{ padding: { xs: '0% 0% 0% 0%', sm: '0% 0px 0% 10px' }, marginBottom: '20px' }} xs={6}>
                                    <Buttonh FontWeight='600 !important' Disabled={FormActualizar.VideoConmemoracion === '' ? true : false} FontSize={{ xs: '16px', sm: '18px' }} Text='Publicar' Type='submit' Size={{ xs: '100%', sm: '200px' }} Color='#fbeb04' ColorHover='white' Textcolor='#000000' BorderColor='2px solid #fbeb04 !important' TextcolorHover='black' />
                                </Grid>
                            </>


                    }

                </Grid>

                <Grid container columns={{ xs: 6, sm: 12, md: 12 }} width={{ xs: '200px', sm: '100%' }} >
                    <Grid sx={{ display: 'flex', justifyContent: 'center', padding: { xs: '0% 0% 0% 0% ', sm: '0% 10px 0% 0%' } }} xs={6}>
                        <Buttonh FontSize={{ xs: '16px', sm: '18px' }} Text='Salir' Size={{ xs: '100%', sm: '200px' }} Color='#D14081' OnClick={() => { OnClickCloseConmemoracion(); handleClick('/Conmemoraciones'); }} ColorHover='white' Textcolor='white' BorderColor='2px solid #D14081 !important' TextcolorHover='#D14081' />
                        {/* <Buttonh FontWeight='600 !important' FontSize={{ xs: '16px', sm: '18px' }} Text='Salir' Size={{xs:'100%',sm:'200px' }} Color={Origen === 'Nueva Conmemoracion' ? '#fbeb04' : '#D14081'} BorderColor='2px solid #D14081' ColorHover='white' Textcolor='#ffff' TextcolorHover='#D14081'  onClick={HandleReset} /> */}

                    </Grid>
                </Grid>


            </Box>
            :
            ActiveStep === 0
                ?
                <Box width='100%' display='flex' flexDirection='column' alignContent='center' flexWrap='wrap'>



                    <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="flex-start" width='100%'>
                        <Buttonh FontWeight='600 !important' Text='Cancelar' Size={{ xs: '100%', sm: '200px' }} Color='#D14081' BorderColor='3px solid #D14081 !important' ColorHover='white' Textcolor='#ffff' TextcolorHover='#D14081' Disabled={false} OnClick={OnClickCancelar} />
                        {/* <Buttonh FontWeight='600 !important' Text='Cancelar' Size={{xs:'100%',sm:'200px' }} Color='#D14081' BorderColor='3px solid #D14081' ColorHover='white' Textcolor='#ffff' TextcolorHover='#D14081' Disabled={false} OnClick={OnClickCancelar} /> */}
                        <Box ml={{ xs: '0px', sm: '40px' }} mt={{ xs: '25px', sm: '0px' }}>
                            <Buttonh FontWeight='600 !important' FontSize={{ xs: '16px', sm: '18px' }} Disabled={FormActualizar.picture === '' && ActiveStep === 0 ? true : false} Text='Siguiente' Size={{ xs: '100%', sm: '200px' }} BorderColor='2px solid #fbeb04 !important' Color='#fbeb04' OnClick={HandleNext} ColorHover='white' Textcolor='black' TextcolorHover='black' />
                        </Box>
                    </Box>
                </Box>

                :
                <Grid ml={{ xs: '0px', sm: '4%' }} container sx={{ display: 'flex', justifyContent: 'start', marginTop: '0%', alignItems: 'center', padding: '0px' }}>
                    <Grid xs={12} sm={6} pr={{ xs: '0px', sm: '10px' }} sx={{ display: 'flex', justifyContent: 'center' }} >

                        <Buttonh FontWeight='600 !important' Text='Regresar' Size={{ xs: '100%', sm: '200px' }} Color='#D14081' BorderColor='2.5px solid #D14081' ColorHover='white' Textcolor='#ffff' TextcolorHover='#D14081' Disabled={false} OnClick={HandleBack} />

                    </Grid>
                    <Grid xs={12} sm={6} pl={{ xs: '0px', sm: '10px' }} mt={{ xs: '25px', sm: '0px' }} >
                        <Buttonh FontWeight='600 !important' FontSize={{ xs: '16px', sm: '18px' }} Disabled={FormActualizar.picture === '' && ActiveStep === 0 ? true : FormActualizar.mensaje === '' ? true : FormActualizar.mensaje === 50 ? FormActualizar.mensajepersonalizado !== '' ? false : true : false} Text='Siguiente' Size={{ xs: '100%', sm: '200px' }} Color='#fbeb04' OnClick={HandleNext} BorderColor='2px solid #fbeb04 !important' ColorHover='white' Textcolor='#000000' TextcolorHover='black' />
                    </Grid>
                </Grid>

    )

}


export default ActionStepConmemoracion